{
  "zh-CN": {
    "hangarPlanner": {
      "title": "机库规划器",
      "lead": "用槽位（你想覆盖的角色）规划理想中的机库，并算出如何从现有机库走到那里：保留什么、熔毁（melt）什么，以及使用哪些升级（CCU）和回购（buy-back）。",
      "createPlan": "新建方案",
      "editPlan": "编辑方案",
      "destroyPlan": "删除方案",
      "confirmDestroy": "删除此方案？你的机库不会受到影响。",
      "share": "通过链接分享",
      "copyShareLink": "复制分享链接",
      "unshare": "停止分享",
      "shared": "已分享",
      "sharedMissing": "此方案未分享，或链接已更改。",
      "addToWishlist": "将待购飞船加入愿望清单",
      "confirmAddToWishlist": "将此方案仍需获取的每艘飞船加入你的愿望清单？",
      "compareWith": "与 %{plan} 比较",
      "compareTitle": "%{left} 对比 %{right}",
      "slotsCount": {
        "one": "%{count} 个槽位",
        "other": "%{count} 个槽位"
      },
      "updatedAt": "更新于 %{date}",
      "empty": {
        "title": "暂无方案",
        "text": "可以从零开始、从你的机库、从你的愿望清单，或复制另一个方案来创建方案。"
      },
      "noSlots": "此方案还没有槽位。请为机库要覆盖的每个角色添加一个槽位。",
      "placeholderRoles": {
        "starter": "日常座驾",
        "cargo": "货运船",
        "exploration": "探索船"
      },
      "useAsFirstSlot": "设为我的第一个槽位",
      "addSlot": "添加槽位",
      "editSlot": "编辑槽位",
      "editSlotOf": "编辑 %{slot}",
      "slotSettings": "名称和筛选条件",
      "removeSlot": "移除槽位",
      "confirmRemoveSlot": "移除此槽位及其中的飞船和获取途径？",
      "openSlotHint": "尚未选择飞船。可添加一艘，如果还没想好也可添加多艘。",
      "addShips": "添加飞船",
      "addCandidates": "%{slot} 的飞船",
      "addToSlot": "添加到槽位",
      "inSlot": "在此槽位中",
      "choose": "选定",
      "chooseHint": "选定此槽位要规划的飞船。其他飞船及其获取途径将从该槽位移除。",
      "removeCandidate": "移除飞船",
      "ownedCount": {
        "one": "你的机库中有 %{count} 艘",
        "other": "你的机库中有 %{count} 艘"
      },
      "notOnSale": "未在售",
      "routes": "获取方式",
      "addRoute": "添加获取 %{ship} 的途径",
      "addRouteShort": "添加途径",
      "editRoute": "获取 %{ship} 的途径",
      "removeRoute": "移除途径",
      "unresolvedUnits": {
        "one": "%{count} 艘飞船尚无获取途径",
        "other": "%{count} 艘飞船尚无获取途径"
      },
      "routeMustEnd": "途径必须以 %{ship} 结束。",
      "upgradeSteps": "升级",
      "stepNumber": "升级 %{number}",
      "addStep": "添加升级",
      "removeStep": "移除升级",
      "sourceMissing": "已不在你的机库中",
      "melts": "熔毁",
      "noMelts": "没有要熔毁的飞船。",
      "addMelt": "熔毁一艘飞船",
      "editMelt": "编辑熔毁",
      "removeMelt": "保留飞船",
      "estimated": "估算",
      "free": "免费",
      "unknownPrice": "未知",
      "fields": {
        "name": "名称",
        "description": "描述",
        "startingCredit": "商店积分",
        "startingCreditInfo": "你已拥有的商店积分，单位为美元。",
        "source": "起点",
        "sourcePlan": "要复制的方案",
        "slotLabel": "角色",
        "slotLabelPlaceholder": "例如：主力货运船",
        "quantity": "飞船数量",
        "startKind": "起始状态",
        "ownedShip": "你机库中的飞船",
        "buyback": "回购 pledge",
        "startModel": "飞船",
        "priceOverride": "实付价格",
        "priceOverrideInfo": "留空则使用当前商店价格，也可填写促销价或 warbond 价格。",
        "upgradeSource": "升级自",
        "ownedUpgrade": "你 RSI 机库中的升级",
        "upgradeTo": "升级为",
        "meltShip": "要熔毁的飞船",
        "meltValue": "积分",
        "meltValueInfo": "熔掉可获得的信用点。留空则使用 RSI 为该礼包列出的价值；机库同步未读取时使用今日商店价格。",
        "slotDescription": "描述",
        "filters": "适合的舰船",
        "filtersInfo": "舰船选择器会按这些筛选条件打开。不符合条件的舰船仍可添加，并会被标记。",
        "priceFrom": "最低价格",
        "priceTo": "最高价格",
        "minCargo": "最少货舱",
        "onSaleOnly": "仅限在售舰船",
        "buybackTokens": "回购代币",
        "buybackTokensInfo": "每个代币可让你用商店信用点支付一次回购。没有代币时，回购需要花新钱。",
        "buybackTokensSynced": "每个代币可让你用商店信用点支付一次回购。你上次的回购同步从 RSI 读取到 %{count} 个；留空即使用该数值。",
        "vatRate": "增值税",
        "vatRateInfo": "RSI 在结账时按你所在地加收的增值税，例如德国为 19。仅适用于新付款；商店信用已包含增值税。"
      },
      "sources": {
        "empty": "空方案",
        "hangar": "我的机库",
        "wishlist": "我的愿望清单",
        "plan": "另一个方案"
      },
      "states": {
        "open": "待定",
        "decided": "已确定",
        "undecided": "未决定"
      },
      "startKinds": {
        "owned": "保留机库中的",
        "store": "商店购买",
        "ingame": "游戏内购买",
        "buyback": "回购"
      },
      "upgradeSources": {
        "store": "商店",
        "owned_ccu": "我的 RSI 机库",
        "buyback": "回购"
      },
      "vehicleStatuses": {
        "kept": "保留",
        "upgraded": "已升级",
        "melted": "已熔毁",
        "pending": "待决定",
        "change": "应更换",
        "unassigned": "不在方案中"
      },
      "changes": {
        "added": "新增",
        "removed": "移除",
        "more": "增多",
        "fewer": "减少",
        "unchanged": "不变"
      },
      "issues": {
        "missing_price": "%{name} 没有已知价格，因此总价未计入它。",
        "not_on_sale": "%{name} 目前未在售。"
      },
      "summary": {
        "title": "费用",
        "spend": "新增支出",
        "meltCredit": "熔毁所得积分",
        "startingCredit": "商店积分",
        "net": "净成本",
        "cashNeeded": "仍需支付",
        "remainingCredit": "剩余积分",
        "estimatedMelts": {
          "one": "%{count} 项为估算",
          "other": "%{count} 项为估算"
        },
        "openSlots": {
          "one": "%{count} 个槽位没有飞船",
          "other": "%{count} 个槽位没有飞船"
        },
        "undecidedSlots": {
          "one": "%{count} 个槽位未决定",
          "other": "%{count} 个槽位未决定"
        },
        "unresolved": {
          "one": "%{count} 艘飞船没有途径",
          "other": "%{count} 艘飞船没有途径"
        },
        "incomplete": "总价不完整",
        "complete": "每艘飞船都有途径和价格。",
        "buybackCash": "用新钱支付的回购",
        "buybacksWithoutToken": {
          "one": "%{count} 次回购没有代币",
          "other": "%{count} 次回购没有代币"
        },
        "tokensShort": {
          "one": "%{count} 次回购使用代币，但你只有 %{available} 个。其余按新钱计算。",
          "other": "%{count} 次回购使用代币，但你只有 %{available} 个。其余按新钱计算。"
        }
      },
      "comparison": {
        "title": "与你的机库对比",
        "yourShips": "你的飞船",
        "noShips": "你的机库中没有飞船。",
        "changes": "变化",
        "noChanges": "没有变化。",
        "toAcquire": "仍需获取",
        "hangar": "机库",
        "plan": "方案",
        "happens": "会发生什么",
        "meltCredit": "%{value} 信用点",
        "leaves": "离开你的机库",
        "notInPlan": "不在方案中",
        "notOwned": "不在你的机库中",
        "lead": "左边是你拥有的每艘飞船，右边是方案需要的每艘飞船，中间是会发生的事。",
        "anotherPlan": "与其他方案比较",
        "tallies": {
          "pending": {
            "one": "待决定 %{count}",
            "other": "待决定 %{count}"
          },
          "change": {
            "one": "应更换 %{count}",
            "other": "应更换 %{count}"
          },
          "kept": {
            "one": "保留 %{count}",
            "other": "保留 %{count}"
          },
          "upgraded": {
            "one": "已升级 %{count}",
            "other": "已升级 %{count}"
          },
          "melted": {
            "one": "已熔 %{count}",
            "other": "已熔 %{count}"
          },
          "toAcquire": {
            "one": "仍需获取 %{count}",
            "other": "仍需获取 %{count}"
          },
          "open": {
            "one": "待定槽位 %{count}",
            "other": "待定槽位 %{count}"
          }
        },
        "costsTitle": "费用",
        "flow": {
          "steps": {
            "one": "%{count} 次升级 · %{price}",
            "other": "%{count} 次升级 · %{price}"
          },
          "shipOf": "第 %{number} 艘，共 %{count} 艘",
          "noRoute": "尚无途径",
          "notCounted": "未计入总额",
          "noShip": "尚无飞船",
          "toDecide": "尚未决定",
          "folded": {
            "kept": {
              "one": "%{count} 艘原样保留",
              "other": "%{count} 艘原样保留"
            },
            "unassigned": {
              "one": "%{count} 艘飞船不在方案中",
              "other": "%{count} 艘飞船不在方案中"
            }
          }
        },
        "changeSides": {
          "in": "新增",
          "out": "移出"
        },
        "unchangedCount": {
          "one": "%{count} 个型号保持不变。",
          "other": "%{count} 个型号保持不变。"
        },
        "after": "方案完成后"
      },
      "metrics": {
        "title": "统计",
        "total": "飞船",
        "uniqueModelsCount": "不同型号",
        "manufacturerCount": "制造商",
        "flightReadyCount": "可飞行",
        "totalCrew": "船员",
        "totalCargo": "货舱（SCU）",
        "totalPledgeValue": "商店价值",
        "largestShip": "最大的飞船",
        "smallestShip": "最小的飞船",
        "classifications": "分类",
        "sizes": "尺寸",
        "productionStatuses": "生产状态"
      },
      "drift": {
        "title": "自创建此方案以来，你的机库发生了变化",
        "missing": {
          "one": "方案使用的 %{count} 艘飞船或 pledge 已不存在。",
          "other": "方案使用的 %{count} 艘飞船或 pledge 已不存在。"
        },
        "changed": {
          "one": "%{count} 艘飞船现在是另一个型号。",
          "other": "%{count} 艘飞船现在是其他型号。"
        },
        "added": "你的机库新增：%{ships}",
        "prices": "价格已变化：规划时为 %{before}，今天为 %{now}。",
        "rebase": "从机库更新"
      },
      "messages": {
        "saved": "方案已保存。",
        "saveFailed": "操作失败，请检查你的输入。",
        "shareCopied": "分享链接已复制。",
        "unshared": "分享链接已失效。",
        "addedToWishlist": {
          "one": "已将 %{count} 艘飞船加入你的愿望清单。",
          "other": "已将 %{count} 艘飞船加入你的愿望清单。"
        },
        "rebased": "方案已根据你的机库更新。",
        "sharingOn": "已开启分享。任何拥有链接的人都可以查看此计划。",
        "copyFailed": "无法复制链接，请从输入框中复制。"
      },
      "filterChips": {
        "priceFrom": "%{price} 起",
        "priceTo": "不超过 %{price}",
        "cargo": "%{cargo} SCU 以上",
        "onSale": "在售"
      },
      "outsideFilters": "不符合此槽位的筛选条件",
      "shareLink": "分享链接",
      "specs": {
        "price": "价格",
        "cargo": "货舱",
        "crew": "船员",
        "size": "尺寸",
        "best": "最佳"
      },
      "readiness": {
        "routed": {
          "one": "%{count} 艘飞船中 %{routed} 艘已有途径",
          "other": "%{count} 艘飞船中 %{routed} 艘已有途径"
        },
        "undecided": "%{slot} 尚未决定",
        "open": "%{slot} 还没有飞船",
        "unresolved": {
          "one": "%{slot}：%{count} 艘飞船没有途径",
          "other": "%{slot}：%{count} 艘飞船没有途径"
        }
      },
      "meta": {
        "undecided": "%{count} 个未决定",
        "open": "%{count} 个待定"
      },
      "route": {
        "stillToReach": "仍需到达",
        "yourRoute": "你的途径",
        "startFirst": "选择飞船的来源以查看途径。",
        "done": "途径以 %{ship} 结束。",
        "startHints": {
          "owned": "你已拥有的飞船。如果不是 %{ship}，请添加将其变为 %{ship} 的升级。",
          "buyback": "你已熔掉、可以从 RSI 回购的礼包。没有回购代币时需要花新钱，不能用商店信用点。",
          "store": "RSI 商店中的新礼包。可以先买更便宜的飞船再升级。",
          "ingame": "在游戏中用 aUEC 购买，因此不花钱。游戏内购买的飞船无法升级，所以必须直接是 %{ship}。"
        },
        "noVehicles": "你的机库中没有可用于此途径的飞船。",
        "noBuybacks": "你没有可回购的礼包。请从你的 RSI 账户同步。",
        "pledgeShip": "礼包中的飞船",
        "isTarget": "同一艘飞船",
        "holdsTarget": "包含该飞船",
        "search": "搜索",
        "noMatch": "没有匹配项。",
        "reaches": "可到达 %{ship}",
        "left": {
          "one": "剩余 %{count}",
          "other": "剩余 %{count}"
        },
        "showAll": {
          "one": "显示全部 %{count} 个升级",
          "other": "显示全部 %{count} 个升级"
        },
        "showFitting": "只显示合适的升级",
        "unknownTarget": "升级到哪艘飞船",
        "startCost": "起点",
        "includesShip": "包含 %{ship}",
        "cheaperOnly": "只列出比 %{ship}（%{price}）便宜的飞船，因为你会从它们升级。",
        "sort": {
          "price": "价格",
          "name": "名称"
        },
        "change": "更改",
        "from": "从",
        "to": "到",
        "todaysPrice": "今日价格：%{price}",
        "noStoreShip": "商店中没有适合这里的舰船。",
        "paidWithCredit": "商店信用",
        "paidWithCash": "新付款",
        "vat": "增值税（%{rate}%）",
        "cashWithVat": "含增值税的新付款",
        "paymentHint": "商店信用可用于商店购买和使用回购令牌的回购。没有令牌的回购需要新付款，信用不足的部分也是如此。",
        "ownedPaid": "已支付",
        "noHeld": {
          "owned_ccu": "你 RSI 机库中的升级没有从 %{ship} 出发的。",
          "buyback": "你的回购升级中没有从 %{ship} 出发的。"
        },
        "direction": {
          "label": "构建途径",
          "forward": "从起点开始",
          "reverse": "从目标倒推"
        },
        "directionHints": {
          "forward": "先选择飞船的来源，再选择把它变为 %{ship} 的升级。",
          "reverse": "从 %{ship} 倒推：选择以它结束的升级，再选择在其起点结束的升级。停在你拥有、可回购或可购买的飞船上。"
        },
        "startPending": "起点待选",
        "reverseStart": "途径从 %{ship} 开始。",
        "unknownSource": "从哪艘飞船升级",
        "noHeldInto": {
          "owned_ccu": "你 RSI 机库中的升级没有以 %{ship} 结束的。",
          "buyback": "你的回购升级中没有以 %{ship} 结束的。"
        },
        "upgradeInto": "升级至 %{ship}",
        "upgradesTo": "至 %{ship}",
        "inHangar": "在你的机库中",
        "buybackAvailable": "可回购",
        "nextStep": "途径现在从 %{ship} 开始。添加升级至它，或选择 %{ship} 作为起点。",
        "addUpgradeInto": "添加升级至 %{ship}",
        "startHere": "从 %{ship} 开始",
        "shipCard": "飞船",
        "useToken": "使用回购代币",
        "withToken": "已用代币支付",
        "buyTarget": "直接购买 %{ship}",
        "startShort": {
          "owned": "机库",
          "buyback": "回购",
          "store": "商店",
          "ingame": "游戏内"
        },
        "ingameNoUpgrades": "游戏内购买的飞船无法升级。请先移除升级。"
      },
      "meltList": {
        "none": "根据 RSI，你的飞船都不可熔。关闭筛选即可任选飞船。",
        "credit": "%{value} 信用点",
        "estimate": "约 %{value}",
        "wholePledge": {
          "one": "熔掉 %{count} 件物品",
          "other": "熔掉整个礼包：%{count} 件物品"
        },
        "meltableOnly": "仅可熔",
        "notMeltable": "不可熔",
        "notSynced": "未同步",
        "noShips": "你没有可用于熔掉的飞船。",
        "inPackage": "属于 %{name}",
        "contents": "一并熔掉",
        "contentsOf": "作为 %{name} 的一部分一并熔掉",
        "unlisted": {
          "one": "另有 %{count} 件机库同步未列出的物品",
          "other": "另有 %{count} 件机库同步未列出的物品"
        }
      },
      "decisions": {
        "keep": "原样保留",
        "upgrade": "升级",
        "melt": "熔炼",
        "change": "标记为应更换",
        "pending": "改回待决定",
        "upgradeTo": "将 %{name} 升级为",
        "keepPending": "保留所有待决定的"
      },
      "slotsTitle": "槽位",
      "editSlots": "编辑槽位"
    }
  }
}
